import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { AddQuickInquiryFormValues } from "src/models/QuickInqury.model";
import ATMSelectValue from "src/components/UI/atoms/formFields/ATMSelectValue/ATMSelectValue";
import ATMRadioButton from "src/components/UI/atoms/ATMRadioButton/ATMRadioButton";
import ATMMultiSelect from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";
import ATMDatePicker from "src/components/UI/atoms/formFields/ATMDatePicker/ATMDatePicker";
import ATMCheckbox from "src/components/UI/atoms/formFields/ATMCheckbox/ATMCheckbox";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";
import useCourse from "src/hooks/useCourse";
import useDispositionLevelOne from "src/hooks/useDisPositions";
import { useGetAllDispositionLevelTwoByLevelOneIdQuery } from "src/services/DispositionLevelTwoServices";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import useInquiryLabels from "src/hooks/useInquiryLabels";
import moment from "moment";

type Props = {
  formikProps: FormikProps<AddQuickInquiryFormValues>;
  onClose: () => void;
};

const SummaryType = [
  {
    label: "Yes",
    value: "YES",
  },
  {
    label: "No",
    value: "NO",
  },
];

const ContactThemOption = [
  {
    label: "On Date",
    value: "ON_DATE",
  },
  {
    label: "On Event",
    value: "ON_EVENT",
  },
];

const AddQuickInquiryForm = ({ formikProps, onClose }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  //Inquiry Label

  const { inquiryLabels, isDataLoading: inquiryLabelsLoading } =
    useInquiryLabels();

  //Inquiry Label Option
  const InquiryLabelOptions = inquiryLabels?.map((el: any, ind: any) => {
    return {
      label: el?.inquiryLabel,
      value: el?._id,
    };
  });

  //ALL COURSE
  const { course, isDataLoading: isCourseLoading } = useCourse();
  const CourseOption = course?.map((el: any) => {
    return {
      label: el?.courseName,
      value: el?._id,
      classroomFees: el?.classroomFees,
    };
  });

  //ALL DisPosition Level One
  const { DispositionLevelOne, isDataLoading: isDispositionLevelOneLoading } =
    useDispositionLevelOne();
  const DispositionLevelOneOption = DispositionLevelOne?.map((el: any) => {
    return {
      label: el?.dispositionFirstName,
      value: el?._id,
    };
  });
  //ALL DisPosition Level Two
  const {
    data: DispositionLevelTwoData,
    isLoading: DispositionLevelTwoDataIsLoading,
    isFetching: DispositionLevelTwoDataIsFetching,
  } = useGetAllDispositionLevelTwoByLevelOneIdQuery(values?.disposition_one, {
    skip: !values?.disposition_one,
  });
  const DispositionLevelTwoOption = DispositionLevelTwoData?.data?.map(
    (el: any) => {
      return {
        label: el?.dispositionSecondName,
        value: el?._id,
      };
    }
  );
  const inquiryTypeOptions = [
    {
      label: "INBOUND",
      value: "INBOUND",
    },
    {
      label: "OUTBOUND",
      value: "OUTBOUND",
    },
    {
      label: "VISIT",
      value: "VISIT",
    },
  ];
  return (
    <div className="flex flex-col p-4">
      <div className="flex items-center justify-between">
        <div className="text-xl font-medium"> Add Quick Inquiry</div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="grid grid-cols-2 gap-4 my-2">
        <div>
          <ATMTextField
            name="name"
            value={values.name}
            onChange={(e) => {
              setFieldValue("name", e.target.value);
            }}
            required
            placeholder="Please Enter Name"
            label="Name"
            onBlur={handleBlur}
          />
        </div>

        <div>
          <ATMTextField
            name="email"
            value={values.email}
            onChange={(e) => {
              setFieldValue("email", e.target.value);
            }}
            label="Email"
            onBlur={handleBlur}
            placeholder="Please Enter Email"
          />
        </div>

        <div>
          <ATMTextField
            name="mobile"
            value={values.mobile}
            onChange={(e) => {
              setFieldValue("mobile", e.target.value);
            }}
            label="Mobile"
            onBlur={handleBlur}
            required
            placeholder="Please Enter Mobile"
          />
        </div>
        {/* Inquiry Type */}
        <div className="">
          <ATMSelect
            name="inquiryType"
            value={values?.inquiryType}
            onChange={(value) => setFieldValue("inquiryType", value)}
            options={inquiryTypeOptions}
            label="Inquiry Type"
            required
          />
        </div>
        {/* Inquiry Label */}
        <div className="">
          <ATMSelect
            name="inquiryLabel"
            value={values?.inquiryLabel}
            onChange={(value) => setFieldValue("inquiryLabel", value)}
            options={InquiryLabelOptions}
            label="Inquiry Label"
            isLoading={inquiryLabelsLoading}
          />
        </div>
        {/*  */}
      </div>
      <div className="grid grid-cols-2 gap-4 my-2">
        <ATMSelectValue
          name="next_followUp_required"
          value={values.next_followUp_required}
          onChange={(newValue) => {
            setFieldValue("next_followUp_required", newValue);
            setFieldValue("contact_them", "");
          }}
          onBlur={handleBlur}
          label="Next FollowUp Required"
          placeholder="Select Next FollowUp Required"
          options={SummaryType}
        />
        {values?.next_followUp_required === "YES" && (
          <div>
            <ATMRadioButton
              label="Contact Them"
              name="contact_them"
              value={values?.contact_them || ""}
              className="  grid-cols-3"
              options={ContactThemOption}
              onChange={(e) => {
                setFieldValue("contact_them", e);
                setFieldValue("next_followUp_date", "");
                setFieldValue("next_followup_time", "");
                setFieldValue("new_batch_start", false);
                setFieldValue("followup_batch_start_course", []);
              }}
            />
          </div>
        )}
      </div>

      <div className="grid xl:grid-cols-3 md:grid-cols-2 gap-4 my-2">
        {values?.contact_them === "ON_DATE" &&
          values?.next_followUp_required === "YES" && (
            <ATMDatePicker
              name="next_followUp_date"
              value={values?.next_followUp_date || null}
              onChange={(newValue) =>
                setFieldValue("next_followUp_date", newValue)
              }
              label="Next Followup  Date "
            />
          )}
        {values?.contact_them === "ON_DATE" &&
          values?.next_followUp_required === "YES" && (
            <ATMTextField
              type="time"
              name="next_followup_time"
              value={moment(values?.next_followup_time, "HH:mm").format("HH:mm")}
              onChange={(e) => {
                let time = moment(e.target.value, "HH:mm");
                setFieldValue("next_followup_time", time);
              }}
              label="Next Followup Time"
              onBlur={handleBlur}
              required
              placeholder="Please Next Followup Time"
            />
          )}
      </div>
      <div>
        {values?.contact_them === "ON_EVENT" &&
          values?.next_followUp_required === "YES" && (
            <div className="grid xl:grid-cols-3  md:grid-cols-2 gap-6 items-center">
              <ATMCheckbox
                name="new_batch_start"
                extraClasses="font-semibold"
                checked={values?.new_batch_start}
                onChange={(newValue) => {
                  setFieldValue("new_batch_start", newValue);
                }}
                label="When New Batch Start For"
              />
              <div className="">
                <ATMMultiSelect
                  name="followup_batch_start_course"
                  value={values?.followup_batch_start_course}
                  onChange={(newValue) =>
                    setFieldValue("followup_batch_start_course", newValue)
                  }
                  onBlur={handleBlur}
                  placeholder="Select Course"
                  isLoading={isCourseLoading}
                  options={CourseOption}
                />
              </div>
            </div>
          )}
      </div>

      <div>
        {values?.next_followUp_required === "NO" && (
          <div className="">
            <ATMTextArea
              name="next_followup_reason"
              value={values?.next_followup_reason}
              onChange={(value) => {
                setFieldValue("next_followup_reason", value);
              }}
              label="Reason"
              placeholder="Enter Reason"
              onBlur={handleBlur}
            />
          </div>
        )}
      </div>
      <div className="border-l-[3px] border-primary-dark px-3 font font-medium text-[18px]  bg-white  text-primary-dark mt-4">
        Disposition Details
      </div>

      <div className="grid xl:grid-cols-3 md:grid-cols-2 gap-4 my-2">
        <div>
          <ATMSelectValue
            name="disposition_one"
            value={values?.disposition_one}
            onChange={(newValue) => {
              setFieldValue("disposition_one", newValue);
              setFieldValue("disposition_two", "");
            }}
            onBlur={handleBlur}
            label="Disposition One"
            placeholder="Select Disposition One"
            options={DispositionLevelOneOption}
            isLoading={isDispositionLevelOneLoading}
          />
        </div>
        <div>
          <ATMSelectValue
            name="disposition_two"
            value={values?.disposition_two}
            onChange={(newValue) => {
              setFieldValue("disposition_two", newValue);
            }}
            onBlur={handleBlur}
            label="Disposition Two"
            placeholder="Select Disposition Two"
            options={DispositionLevelTwoOption}
            isLoading={
              DispositionLevelTwoDataIsLoading ||
              DispositionLevelTwoDataIsFetching
            }
          />
        </div>
      </div>
      <div>
        <ATMTextArea
          name="summary"
          value={values.summary}
          onChange={(e) => {
            setFieldValue("summary", e);
          }}
          label="Summary"
          onBlur={handleBlur}
          placeholder="Enter Summary"
        />
      </div>
      <div className="mt-5">
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default AddQuickInquiryForm;
